<template>
    <div class="container my-5 verify-whatsapp-component">

        <div class="row justify-content-center">
            <div class="col-md-12">

                <div class="d-flex flex-column justify-content-center align-items-center">
                    <h1 class="text-center"> {{ translate.login.whatsappRegistration.confirmPhoneNumber }} </h1>
                    <p class="mt-2 text-center text-size-slightly-bigger">
                        {{ translate.login.whatsappRegistration.pleaseClickButtonBelow }} </p>
                    <div class="text-code">{{ whatsappCode }}</div>
                    <a :href="urlWhatsapp" target="_blank" class="btn btn-secondary my-5">
                        <icon-component :icon="fa_whatsapp()" height="1.1em" width="1.1em" viewBox="-50 0 512 512"
                                        class="mr-2"></icon-component>
                        {{ translate.login.whatsappRegistration.sendCode }}
                    </a>
                    <div class="not-verified-error-text mt-4 text-center" v-if="notYetVerified">
                        {{ translate.login.whatsappRegistration.notYetVerified }}
                    </div>
                </div>

                <p class="text-size-slightly-bigger mt-2">
                    {{ translate.login.whatsappRegistration.youWillProceedAutomatically }}
                </p>
                <p class="mt-4">{{ translate.login.whatsappRegistration.contactUsIfTrouble }}</p>
                <p class="mt-4">{{ translate.login.whatsappRegistration.pleaseNote }}
                    <span class="text-bold">{{ whatsappNumber }}</span>
                </p>

            </div>
        </div>

    </div>
</template>

<script>

import IconComponent from "@/components/global/IconComponent.vue";
import {fa_whatsapp} from "@/core/constants/icons";
import {setCookie} from "@/core/utils/helpers/cookieHelper";
import {mapState} from "vuex";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => {
    return {
        intervalId: 0,
        notYetVerified: false,
    }
};

function mounted() {
    const code = this.whatsappCode;
    const channel = `whatsapp.verification.${this.sentFromPhone.replace('+', '')}.${code}`;

    this.intervalId = setInterval(this.checkStuckRegistration, 15000)

    $.getScript(regionRelativeUrl('/js/app-sockets.js', true)).then(() => {
        Echo.channel(channel)
            .listen('.whatsappVerification', async (data) => {
                if (data && data.code === code && data.isVerified) {
                    toastr.success(this.translate.account.phoneVerification.phoneVerified)

                    if (data.token) {
                        setCookie('jwt', data.token)
                        window.location.href = regionRelativeUrl('/users/account/');

                        return;
                    }

                    window.location.href = regionRelativeUrl('/users/login/');
                }
            });
    });
}

async function checkStuckRegistration() {
    const [err, response] = await to(
        api.auth.checkStuckWhatsappRegistration({
            phoneNumber: this.sentFromPhone,
            code: this.whatsappCode,
        })
    )

    const token = _.get(response, 'data.token');

    if (token) {
        setCookie('jwt', token)
        window.location.href = regionRelativeUrl('/users/account/');
        clearInterval(this.intervalId)

        return;
    }

    this.notYetVerified = true;
}

export default {
    mounted,
    data,
    components: {IconComponent},
    props: ['userIdHash', 'whatsappCode', 'whatsappNumber', 'sentFromPhone'],
    methods: {
        fa_whatsapp,
        checkStuckRegistration,
    },
    computed: {
        ...mapState([
            'translate'
        ]),
        urlWhatsapp() {
            return `https://api.whatsapp.com/send/?phone=${this.whatsappNumber}&text=${encodeURIComponent(this.whatsappCode)}`;
        },
    },
    beforeDestroy() {
        clearInterval(this.intervalId)
    },
};
</script>
